module.exports = __webpack_public_path__ + "static/img/footer-commander.9c2769f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/footer-commander.png
// module id = HMsP
// module chunks = 0